import { HeaderCell, Row } from '../InterestTableDTO';

export interface State {
    error: boolean;
    data: Row[];
    headers: HeaderCell[];
    loading: boolean;
}

export const INITIAL_TABLE_STATE: State = {
    error: false,
    data: [],
    headers: [],
    loading: true,
};
